import { render } from "./SocialGraphLegend.vue?vue&type=template&id=0afa767a&scoped=true&ts=true"
import script from "./SocialGraphLegend.vue?vue&type=script&lang=ts"
export * from "./SocialGraphLegend.vue?vue&type=script&lang=ts"

import "./SocialGraphLegend.vue?vue&type=style&index=0&id=0afa767a&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0afa767a"]])

export default __exports__